import { mdiDotsHorizontal } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const More = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            path={mdiDotsHorizontal}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default More
